module.exports = __webpack_public_path__ + "img/Logo.51137865.png";